export const env = {
    uploadImageUrl: 'https://file.sport-syy.com',
    OSSAccessKeyId: 'LTAI5t6MfcJVgeYCXoRvGUUM',
    timeout: 30000,
    AccessKeySecret: 'Ggiw2K3svMQcqF4XhMfmYkHSpTyVs0'
}